module.exports = __webpack_public_path__ + "img/mobileNoFooter.df897090.jpg";